import {CSSProperties, HTMLProps} from 'react'
import _ from 'lodash'
import {Button, Popup} from 'semantic-ui-react'
import {ConfirmButton} from '@/components/confirm-button'
import {goodBadLabelStyle} from '@/utils/colors'
import './style.css'

export interface IWordProps extends HTMLProps<HTMLDivElement> {
  word: string
  score?: number
  labelScore?: number
  readOnly?: boolean
  canDelete?: boolean
  onSet: (word: string, score: number) => void
  onDeleteWord: (word: string) => void
  computeWordStyle?: (word: string) => React.CSSProperties | undefined
}

export function Word(props: IWordProps) {
  const {
    word,
    score,
    labelScore,
    readOnly,
    canDelete,
    onSet,
    onDeleteWord,
    computeWordStyle,
    ...rest
  } = {
    canDelete: true,
    ...props,
  }
  let itemStyle: CSSProperties | undefined =
    labelScore !== undefined ? goodBadLabelStyle(labelScore / 5) : undefined
  if (computeWordStyle)
    itemStyle = {
      ...itemStyle,
      ...computeWordStyle(word),
    }
  return (
    <Popup
      disabled={readOnly}
      size='tiny'
      trigger={
        <div
          className='word'
          style={itemStyle}
          {...rest}
        >
          {word}
          {_.isNumber(score) ? `: ${score.toFixed(2)}` : undefined}
          {!readOnly && canDelete && labelScore !== undefined ?
            <ConfirmButton
              compact
              size='tiny'
              icon='delete'
              color='red'
              confirmText='Delete label?'
              onClick={() => onDeleteWord(word)}
            />
          : null}
        </div>
      }
      openOnTriggerMouseEnter={false}
      closeOnTriggerMouseLeave={false}
      closeOnTriggerBlur={false}
      content={
        <div
          style={{
            display: 'flex',
            gap: '0.5em',
          }}
        >
          <Button.Group
            compact
            size='tiny'
          >
            {_.map(_.range(0, 6), (s) => {
              return (
                <Button
                  key={s}
                  content={s}
                  // disabled={isEditing}
                  color={_.isEqual(labelScore, s) ? undefined : 'grey'}
                  onClick={() => onSet(word, s)}
                />
              )
            })}
          </Button.Group>
        </div>
      }
      style={{
        zIndex: 9999999,
      }}
    />
  )
}
